import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <div className="mb-8"><Logo /></div>
        <h2 className="nk-head text-2xl font-bold text-slate-900">Set new password</h2>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <input
            data-testid="reset-password" type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)} minLength={6}
            className="w-full border border-slate-200 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="New password"
          />
          {error && <div className="text-sm text-red-600">{error}</div>}
          <button type="submit" data-testid="reset-submit"
            className="w-full rounded-md py-2.5 text-sm font-semibold text-white" style={{ background: "var(--nk-navy)" }}>
            Update password
          </button>
        </form>
        <div className="text-center mt-4">
          <Link to="/login" className="text-xs text-slate-500 hover:text-blue-600">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
